import React, { useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const AutoGeneratedAssets = ({ data }) => {
  const i18n = useContext(I18nContext);

  const {
    autoGeneratedTextOptOut,
    autoGeneratedImageOptOut,
    finalUrlExpansionOptOut,
  } = data || {};

  const autoGenAssetsSummary = useMemo(() => {
    if (finalUrlExpansionOptOut && autoGeneratedTextOptOut && autoGeneratedImageOptOut) {
      return i18n.getString(_TL_('Off: Do not use autogenerated assets in ads.'));
    }
    return i18n.getString(_TL_('On: You’ve enabled autogenerated assets for your ads.'));
  }, [i18n, finalUrlExpansionOptOut, autoGeneratedTextOptOut, autoGeneratedImageOptOut]);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Autogenerated Assets') }}>
      <Text>{autoGenAssetsSummary}</Text>
    </PropertyRow>
  );
};

AutoGeneratedAssets.propTypes = {
  data: PropTypes.shape({
    autoGeneratedTextOptOut: PropTypes.bool,
    autoGeneratedImageOptOut: PropTypes.bool,
    finalUrlExpansionOptOut: PropTypes.bool,
    finalUrlExpansions: PropTypes.arrayOf(PropTypes.string),
  }),
};

AutoGeneratedAssets.defaultProps = {
  data: {},
};
